import { render, staticRenderFns } from "./change-info.vue?vue&type=template&id=c2f1eba4&"
import script from "./change-info.vue?vue&type=script&lang=js&"
export * from "./change-info.vue?vue&type=script&lang=js&"
import style0 from "./change-info.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports